import { useEffect, useState } from "react";
import mainservice from "../../../services/MainService";
import './EventEdit.scss'
import { EventDTO } from "../../DTO/EventDTO";
import { Status } from "../day/dayView";
import Spinner from "../../../components/Spinner/Spinner";
import PlaningToolRoot, { State } from "../PlaningToolRoot";
import { ObjectKind } from "../../models/objectKinds";
import DaysView from "../day/daysView";
import { DayDTO } from "../../DTO/DayDTO";
import { SeminarDayDTO } from "../../DTO/SeminarDayDTO";
import ModuleDTO from "../../DTO/ModuleDTO";
import DayModuleDTO from "../../DTO/DayModuleDTO";
import { GenericDTO } from "../../DTO/GenericDTO";
import MaterialsView from "../materialsView";
import { PublishKind } from "../../models/publishKinds";
import { MItem } from "../Menu";
import { BuildingBlocks } from "./BuildingBlocks";
import { EditItem } from "./EditItem";
import { SeminarDTO } from "../../DTO/SeminarDTO";
import { PlaningDetails } from "./PlaningDetails";
import H2Edit from "../../elements/H2Edit";
import PersonList from "../Person/PersonList";
import { PersonKind } from "../Person/PersonKind";
import { RightDrawerContent } from "../RightDrawer";
import FotoprotokollView from "../fotoprotokollView";
import EditFieldsPrinter from "../../editFields/EditFieldsPrinter";
import { LexwareButton } from "../Lexware/LexwareButton";
import { EventSpecificEditFields3 } from "../../editFields/EventSpecificEditFields2";
import {Credential} from "../Generic/Credentials";
import LogView from "../Generic/LogView";
import { EventSpecificEditInvoices } from "../../editFields/EventSpecificEditFields1";
import BroadcastRightButton from "../../elements/BroadcastRightButton";
import { DisplayKind } from "../../DTO/Materialkinds";
import { Button, Box, Tabs, Tab, Stack } from "@mui/material";
import PrintIcon from '@mui/icons-material/Print';
import { EventOrderClarificationFields } from "../../editFields/EventOrderClarificationFields";
import ModulePersonConflicts from "./ModulePersonConflicts";

enum LeftTab {
  details,
  info,
  days,
  materiallist,
  fotoprotokoll,
  personlist,
  invoices,
  files,
  logs,
  orderClarification,
  modulePersonConflict,
}

enum Env {
  none = 0,
  design = 1,
  planing = 2,
  all = 3,
}

const LeftTabs = [
  {
    id: LeftTab.details,
    name: 'Planung',
    env: Env.all,
  },
  {
    id: LeftTab.invoices,
    name: 'Faktura',
    env: Env.all,
  },
  {
    id: LeftTab.orderClarification,
    name: 'Auftragsklärung',
    env: Env.all,
  },
  {
    id: LeftTab.info,
    name: 'Konzept',
    env: Env.all,
  },
  {
    id: LeftTab.days,
    name: 'Ablauf',
    env: Env.all,
  },
  {
    id: LeftTab.materiallist,
    name: 'Packliste',
    env: Env.planing,
  },
  {
    id: LeftTab.fotoprotokoll,
    name: 'Fotoprotokoll',
    env: Env.planing,
  },
  {
    id: LeftTab.personlist,
    name: 'TN-Info',
    env: Env.planing,
  },
  {
    id: LeftTab.files,
    name: 'Dateien',
    env: Env.all,
  },
  {
    id: LeftTab.logs,
    name: 'Sys',
    env: Env.all,
  },
  {
    id: LeftTab.modulePersonConflict,
    name: 'Sequenz-TN-Konflikte',
    env: Env.planing,
  }
]

export default function EventEdit(props: {
  isTemplate?: boolean,
}) {
  const id = mainservice.nav.getVal('id')
  const [Event] = useState(props.isTemplate === true ? new SeminarDTO({id: mainservice.nav.getVal('id') as string || ''}) : new EventDTO({id: id as string || ''}))
  const page = mainservice.nav.getVal('page') || (props.isTemplate === true ? LeftTab.info : LeftTab.details)
  const [status, setStatus] = useState(Status.loading)
  const [dayStatus, setDayStatus] = useState(Status.loading)
  const [currentLeftTab, setCurrentLeftTab] = useState(page)
  const [rerender, setRerender] = useState(0)
  const [editItem, setEditItem] = useState(new GenericDTO({id: -1}))
  const [leftDrawerBroadcastKey, setLeftDrawerBroadcastKey] = useState('')
  const [editObjectKind, setEditObjectKind] = useState(-1)
  const [showLeftDrawer, setShowLeftDrawer] = useState(false)
  const [seminarName, setSeminarName] = useState(Event.name)
  const [reloadRightSide, setReloadRightSide] = useState(1)
  const [currentActiveDay, setCurrentActiveDay] = useState(-Status.dayView)
  const broadCastBackKeyReload = `EventReload-${Event.id}`
  const broadCastBackKeySwitchTemplate = `EventSwitchTemplate-${Event.id}`

  const leftTabs = LeftTabs.filter(lt => !props.isTemplate || (lt.id !== LeftTab.invoices && lt.id !== LeftTab.files && lt.id !== LeftTab.details && lt.id !== LeftTab.personlist && lt.id !== LeftTab.fotoprotokoll))

  function init () {
    Event.getFromServer().then((d) => {
      setSeminarName(Event.name)
      if (d instanceof SeminarDTO) {
        d.getChildrenFromServer().then(() => {
          setSeminarName(d.name)
          setRerender(new Date().getTime())
          setStatus(Status.standard)
        })
      } else {
        setStatus(Status.standard)
      }
    }).catch((err) => {
      console.log('err', err)
    })
  }
  useEffect(() => {
    init()
  }, [])

  mainservice.registerToBroadcast(`EventEdit-${Event.id}`,
    async (key: string, _value: any) => {
      const backData = _value as {position: number, item: ModuleDTO, type: 'time' | 'position' | 'template2seminar' | 'duration'}
      if (key === broadCastBackKeyReload) {
        // const oldStatus = status
        setStatus(Status.loading)
        await Event.getFromServer()
        setStatus(Status.standard)
      }
      const newEventData = _value as {id: number, name: string}
      if (key === broadCastBackKeySwitchTemplate && newEventData.id && newEventData.id !== Event.id) {
        setStatus(Status.loading)
        // alert(`changing template ${newEventData.id} ${newEventData.name}`)
        await Event.addUp(newEventData.id)
        setStatus(Status.standard)
      }
    }
  )
  
  // Select the right Menu item:
  let menuItem = MItem.planer
  if (Event.deletedDate) {
    menuItem = MItem.trash
  } else if (Event.getTagsByKind('contractState')[0]?.special?.search('leads') > -1) {
    menuItem = MItem.leads
  } else if (props.isTemplate === true) {
    menuItem = MItem.designer
  }

  return <PlaningToolRoot
    standalone={true}
    menuItem={menuItem}
    mainContentClass={`flex flex-column mh100noScroll ${Event.deletedDate ? 'w3-border w3-border-red' : ''}`}
    topMenu={
      <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
        <Tabs value={leftTabs.findIndex(lt => lt.id === currentLeftTab)} onChange={(event, newValue) => {
          const lt = leftTabs[newValue]
          setCurrentLeftTab(lt.id)
          mainservice.nav.setPage(lt.id)
        }}>
          {
            leftTabs.map((lt, index) => {
              return <Tab
                key={`left-tab-${lt.id}`}
                label={lt.name}
                id={LeftTab[lt.id]}
              />
            })
          }
        </Tabs>
      </Box>
    }
    rightDrawer={(currentLeftTab !== LeftTab.days && currentLeftTab !== LeftTab.info) ? undefined : <BuildingBlocks
      editItem={(item: any, objectKind: ObjectKind) => {
        setEditItem(item)
        if (editObjectKind !== objectKind) {
          setEditObjectKind(objectKind)
        }
        setShowLeftDrawer(true)
      }}
      reloadTrigger={reloadRightSide}
    />}
    startStateRightDrawer={(currentLeftTab !== LeftTab.days && currentLeftTab !== LeftTab.info) ? State.closed : State.open}
    showLeftDrawer={showLeftDrawer}
    leftDrawer={
      editItem ?
        <EditItem
          close={() => {
            setReloadRightSide(reloadRightSide + 1)
            setShowLeftDrawer(false)
            setTimeout(() => {
              setEditItem(new GenericDTO({id: -1}))
            }, 300)
          }}
          item={editItem}
          objectKind={editObjectKind}
          rerenderRightSide={() => {
            setReloadRightSide(reloadRightSide + 1)
          }}
          broadcastKey={leftDrawerBroadcastKey}
        /> : undefined
    }
  >
    

    <Box
      className='contentHeader'
      sx={{ borderBottom: 1, borderColor: 'divider' }}
    >
      <Box sx={{
        paddingLeft: '16px', paddingRight: '16px'
      }}>
        <div className='flex justify-content-space-between w100'>
          <H2Edit
            value={Event.getName()}
            onChange={async (newValue) => {
              await Event.setName(newValue)
              setRerender(rerender + 1)
            }}
            oldValue={Event.getUpName(true)}
            resetToOldValue={async () => {
              await Event.setName('')
              setRerender(rerender + 1)
            }}
          />
          <div>
            <Button
              variant="outlined"
              onClick={() => {
                // var element = document.getElementById('event-print');
                var element = document.getElementsByClassName('PlaningToolRootMainContentHolder')[0]
                if (currentLeftTab === LeftTab.personlist) {
                  element = document.getElementsByClassName('printList1')[0]
                }
                var opt = {
                  margin:       20,
                  filename:     Event.name + '.pdf',
                  image:        { type: 'jpg', quality: 1 },
                  html2canvas:  { scale: 1 },
                  jsPDF:        { unit: 'mm', orientation: 'portrait', format: 'a4' },
                };
                // @ts-ignore
                html2pdf().from(element).set(opt).save();
              }}
            ><PrintIcon/></Button>
          </div>
        </div>

      </Box>
      {
        Event.getPropV1('data', 'uniqueEventId') &&
          <Box sx={{
            paddingLeft: '16px', paddingRight: '16px',
            marginTop: '8px',
          }}>
            #{Event.getPropV1('data', 'uniqueEventId')}
          </Box>
      }
    </Box>
    { status === Status.loading ? <Spinner /> :
      <div className='flex-grow' id='event-print'>
        { currentLeftTab === LeftTab.details && Event instanceof EventDTO &&
          <PlaningDetails event={Event} />
        }
        { currentLeftTab === LeftTab.invoices && Event instanceof EventDTO &&
          <div className='contentPart' id='invoices'>
            <div className='contentHeader'>
              <h2>Faktura</h2>
            </div>
            <EditFieldsPrinter
              fields={Event.getEditFields(EventSpecificEditInvoices)}
              item={Event}
              rerenderParent={() => {
                setRerender(rerender + 1)
              }}
            />
            <LexwareButton
              item={Event}
              kind='bill'
              reloadTrigger={() => {
                setRerender(rerender + 1)
              }}
              displayBillList={true}
              className='w3-margin-top'
            />
          </div>
        }
        { currentLeftTab === LeftTab.days &&
          <DaysView
            identKey='leftSide'
            items={Event.getDays()}
            getItems={async () => {
              await Event.getChildrenFromServer()
              return Event.getDays()
            }}
            parent={Event}
            rerender={rerender}
            addItem={async (position: number, item: DayDTO) => {
              await Event.addDay(position, item)
              setRerender(new Date().getTime())
            }}
            trashItem={async (day: SeminarDayDTO) => {
              await Event.trashDay(day)
              setRerender(new Date().getTime())
            }}
            setDayStatus={setDayStatus}
            dayStatus={dayStatus}
            parentObjectKind={Event.objectKind}
            parentPublishKind={Event.publishKind}
            rerenderRightSide={() => {
            }}
            setEditItem={(module: ModuleDTO | DayModuleDTO, broadcastKey?: string) => {
              if (broadcastKey !== undefined) {
                setLeftDrawerBroadcastKey(broadcastKey)
              }
              setEditItem(module)
              setEditObjectKind(module.objectKind)
              setShowLeftDrawer(true)
            }}
            currentActiveDay={currentActiveDay}
            setCurrentActiveDay={setCurrentActiveDay}
          />
        }
        { currentLeftTab === LeftTab.materiallist &&
          <>
            <MaterialsView
              items={[]}
              identKey={`seminar-${Event.id}`}
              parentPublishKind={PublishKind.isSeminar}
              parentObjectKind={ObjectKind.seminar}
              getItems={async () => {
                return await Event.getMaterialList()
              }}
              displayKind={DisplayKind.list}
              parent={Event}
              checklists={[
                {
                  title: 'Gepackt',
                  key1: 'checklist-packed',
                },
                {
                  title: 'Produziert',
                  key1: 'checklist-produced',
                },
              ]}
            />
          </>
        }
        { currentLeftTab === LeftTab.fotoprotokoll &&
          <>
            <FotoprotokollView
              items={[]}
              identKey={`seminar-${Event.id}`}
              parentPublishKind={PublishKind.isSeminar}
              parentObjectKind={ObjectKind.seminar}
              getItems={async () => {
                return await Event.getMaterialList()
              }}
              displayKind={Status.list}
              parent={Event}
              checklists={[
                {
                  title: 'Gepackt',
                  key1: 'checklist-packed',
                }
              ]}
            />
          </>
        }
        {
          currentLeftTab === LeftTab.modulePersonConflict &&
          <ModulePersonConflicts
            id={Event.id}
          />
        }
        {
          currentLeftTab === LeftTab.personlist &&
          <>
          <div
            style={{display: 'none'}}
          >
            <PersonList
              eventId={Event.id}
              personTagParent={Event as EventDTO}
              personKind={PersonKind.generic}
              headline={'Teilnehmer*innen'}
              noSearch={true}
              compact={'printList1'}
              className={'printList1'}
              selectAllButton={true}
            />
          </div>
          <PersonList
            eventId={Event.id}
            personTagParent={Event as EventDTO}
            personKind={PersonKind.generic}
            headline={'Teilnehmer*innen'}
            noSearch={true}
            compact={'joinedEvents'}
            className={'joinedEvents'}
            selectAllButton={true}
          />
          </>
        }
        {
          currentLeftTab === LeftTab.orderClarification &&
          <>
            <div className='contentPart w3-padding'>
              <EditFieldsPrinter
                fields={Event.getEditFields(EventOrderClarificationFields)}
                item={Event}
              />
          </div>
          </>
        }
        { currentLeftTab === LeftTab.info &&
        <>
          <div className='contentPart w3-padding'>
            <EditFieldsPrinter
              fields={Event.getEditFields()}
              item={Event}
            />
          </div>
          <div className='contentPart w3-padding'>
            <div className='contentHeader'>
              <h3>Assets</h3>
            </div>
            <Box
              sx={{
                padding: '0 16px',
              }}
            >
              <MaterialsView
                items={Event.getMaterialItems()}
                getItems={async () => {
                  await Event.getChildrenFromServer()
                  return Event.getMaterialItems()
                }}
                identKey={`seminar-view-${Event.id}-`}
                parentObjectKind={Event.objectKind}
                parentPublishKind={Event.publishKind}
                addItem={async (position, item) => {
                  await Event.addMaterialItem(position, item)
                  setRerender(new Date().getTime())
                }}
                displayKind={DisplayKind.edit}
                trashItem={async (item) => {
                  await Event.trashMaterialItem(item)
                  setRerender(new Date().getTime())
                }}
                reloadTrigger={rerender}
                editItem={(item: GenericDTO, objectKind: ObjectKind) => {
                  mainservice.broadcast('rightDrawerOpen', {
                    id: item.id,
                    broadCastBackKey: broadCastBackKeyReload,
                    contentType: RightDrawerContent.editMaterial
                  })
                }}
              />
            </Box>
          </div>

          <div className='contentPart' id='eventSeminar'>
            <div className='contentHeader'>
              <h2>Veranstaltungsvorlage</h2>
            </div>
            <div className='w3-padding'>
              {Event.getUpName(false) || 'Keine Vorlage gewählt'}
            </div>
            <Stack spacing={2} direction={'row'} sx={{
              marginLeft: '16px',
              marginTop: '16px'
            }}>
              <BroadcastRightButton
                contentType={RightDrawerContent.selectSeminar}
                broadCastBackKey={broadCastBackKeySwitchTemplate}
                validateBeforeClick={() => {
                  if(window.confirm('ACHTUNG - Beim wählen einer anderen Veranstaltungsvorlage gehen sämtliche Ablaufinformationen verloren! Trotzdem fortfahren?')) {
                    return true
                  }
                  return false
                }}
                title={`Vorlage wählen`} />
              {
                Event.up[0]?.name &&
                <Button
                  variant="outlined"
                  onClick={async () => {
                    const upId: number = parseInt(Event.up[0]?.id + '', 10)
                    if (upId && window.confirm('Vorlage wirklich lösen?')) {
                      setStatus(Status.loading)
                      await Event.unsetUp(upId)
                      setStatus(Status.standard)
                    }
                  }}
                >
                  Vorlage Lösen
                </Button>
              }
            </Stack>
          </div>

          <div className='contentPart' id='backing'>
            <div className='contentHeader'>
              <h2>Backen</h2>
            </div>
            <p className='w3-margin-left w3-margin-top'>Um diese Veranstaltung zu Archivieren, so dass nichts mehr geändert wird - hier auf "Backen" klicken.</p>
            <button
              className='dangerButton w3-margin-left'
              onClick={async () => {
                await Event.bake()
                // setRerender(rerender + 1)
                window.location.reload()
              }}
            >Jetzt backen</button>
            {
              Event.getPropV1('log', 'bakedDate') &&
              // eslint-disable-next-line react/jsx-no-undef
              <div className='w3-margin-left w3-margin-top'>Zuletzt gebacken <Credential item={Event} key1='log' key2='bakedByUserId' prefix='von ' /><Credential item={Event} key1='log' key2='setUpName' prefix=', ursprünglicher Designname: ' /></div>
            }
          </div>
        </>
        }
        { currentLeftTab === LeftTab.files && Event instanceof EventDTO &&
          <div className='contentPart' id='invoices'>
            <div className='contentHeader'>
              <h2>Dateien</h2>
            </div>
            <div className='w3-padding'>
              <EditFieldsPrinter
                fields={Event.getEditFields(EventSpecificEditFields3)}
                item={Event}
              />
            </div>
          </div>
        }
        { currentLeftTab === LeftTab.logs &&
          <div className='contentPart' id='invoices'>
            <LogView getLogs={async () => await Event.getLogs()} className='w3-margin-top'/>
          </div>
        }
      </div>
    }
  </PlaningToolRoot>
}



